import { useState } from 'react'
import mirapassLogo from '../../assets/landing/logo-mirapass.png'

export interface NavItem {
  href: string
  label: string
  external?: boolean
}

interface SiteHeaderProps {
  /** ロゴのリンク先（トップページでは #top、他ページでは / ） */
  logoHref: string
  navItems: NavItem[]
  onLogin: () => void
}

/** 公開サイト（トップ／アントレ部）で共通のヘッダー */
const SiteHeader = ({ logoHref, navItems, onLogin }: SiteHeaderProps) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const handleLogin = () => {
    setIsMenuOpen(false)
    onLogin()
  }

  const linkProps = (item: NavItem) =>
    item.external ? { target: '_blank', rel: 'noopener noreferrer' } : {}

  return (
    <header>
      <div className="wrap nav">
        <a href={logoHref} className="logo" aria-label="MiraPASS">
          <img src={mirapassLogo} alt="MiraPASS" className="logo-img" />
        </a>
        <nav className="nav-links" aria-label="メイン">
          {navItems.map(item => (
            <a key={item.href} href={item.href} {...linkProps(item)}>{item.label}</a>
          ))}
        </nav>
        <div className="nav-right">
          <button type="button" className="nav-login" onClick={handleLogin}>ログイン</button>
        </div>
        <button
          className="burger"
          aria-label="メニューを開く"
          aria-expanded={isMenuOpen}
          onClick={() => setIsMenuOpen(open => !open)}
        >
          <span></span><span></span><span></span>
        </button>
      </div>
      <div className={`mmenu${isMenuOpen ? ' open' : ''}`}>
        {navItems.map(item => (
          <a key={item.href} href={item.href} {...linkProps(item)} onClick={() => setIsMenuOpen(false)}>
            {item.label}
          </a>
        ))}
        <button type="button" onClick={handleLogin}>ログイン</button>
      </div>
    </header>
  )
}

export default SiteHeader
